import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { LectionaryItemMap } from 'app/objects';
import { MappingsService } from '../../services/mappings.service';

@Component({
  selector: 'app-lectionary-item-name-edit-show-mappings',
  templateUrl: './lectionary-item-name-edit-show-mappings.component.html',
  styleUrls: ['./lectionary-item-name-edit-show-mappings.component.css']
})
export class LectionaryItemNameEditShowMappingsComponent implements OnInit {

  @Input() public lectionaryItemNameId: number;
  public maps: LectionaryItemMap[];
  public isLoading: boolean = false;

  constructor(public mapService: MappingsService) { }

  ngOnInit() {
    this.GetMappings();
  }

  private GetMappings(): void {
    this.isLoading = true;
    this.mapService.getMappingsForLectionaryItemName(this.lectionaryItemNameId).then((s) => {
      this.maps = s;
      this.isLoading = false;
    })
    .catch((err)=> {
      alert(err);
      this.isLoading = false;
    })
  }

}
